import ClientInputGroupInsurancePlansAndRiders from './client-input-group-insurance-plans-and-riders'

export default function SecondStep() {
    
    return (
        <div className='grid grid-cols-1 gap-4'>
            <ClientInputGroupInsurancePlansAndRiders />
        </div>
    )
}